import {Weet} from '@/store/weet/weetModel';

/**
 * Offline mode (SCORM export): the weet and all its assets are packaged with the player.
 * The package defines window.WEET_OFFLINE_DATA (loaded by a plain <script>, no XHR needed) :
 *  - weet   : the weet representation, media / subtitle urls already rewritten to local relative paths
 *  - images : original image url (as found in the representation) -> local relative path
 *  - texts  : url (local subtitle path, mdi icon key...) -> text content (srt, svg)
 */
export interface OfflineWeetData {
    weet: Weet;
    images: { [url: string]: string };
    texts: { [url: string]: string };
}

export const getOfflineData = (): OfflineWeetData | undefined => {
    // @ts-ignore
    return window.WEET_OFFLINE_DATA;
};

export const isOfflineMode = (): boolean => {
    return !!getOfflineData();
};

export const getOfflineWeet = (): Weet | undefined => {
    const data = getOfflineData();
    // clone, the store must not mutate the packaged data
    return data ? JSON.parse(JSON.stringify(data.weet)) : undefined;
};

export const getOfflineImageURL = (imageURL: string): string | undefined => {
    return getOfflineData()?.images[imageURL];
};

export const getOfflineText = (url: string): string | undefined => {
    return getOfflineData()?.texts[url];
};

export const getOfflineIconKey = (iconMD: string): string => {
    return 'mdi/' + iconMD + '.svg';
};
